/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum UrlProtocols {
    Smtp = 'smtp://',
    Https = 'https://',
}
